import { getOpenStatus } from "@/lib/hours";

const STYLES = {
  open: { dot: "bg-emerald-500", text: "text-emerald-400" },
  closed: { dot: "bg-red-500", text: "text-red-400" },
  temp_closed: { dot: "bg-amber-500", text: "text-amber-400" },
  unknown: { dot: "bg-zinc-500", text: "text-zinc-400" },
};

export default function OpenStatus({ location, className = "" }) {
  const status = getOpenStatus(location);
  const style = STYLES[status.state] || STYLES.unknown;
  return (
    <span className={`inline-flex items-center gap-2 text-sm font-medium ${style.text} ${className}`} data-testid="open-status">
      <span className={`h-2 w-2 rounded-full ${style.dot}`} aria-hidden="true" />
      {status.label}
    </span>
  );
}
